import FixaButton from "@coworker/apprestructured/src/shared/wrappers/FixaButton/FixaButton";
import { FixaText } from "@coworker/apprestructured/src/shared/wrappers/FixaText/FixaText";
import LinkOutIconPath from "@coworker/apprestructured/src/shared/wrappers/FixaSSRIcon/paths/LinkOutIconPath";
import styles from "./unauthorizedpage.module.css";
import { useTranslation } from "@coworker/locales";

const TEAM_MGMT_MYIDENTITY_URL =
  "https://myidentity.apps.ikea.com/IdentityManager/page.axd?ContextID=VI_ITShop_ProductSelection&uid_accproduct=14c52d7b-ce0e-4f2a-984b-d585a523664a";

interface Props {
  titleKey: string;
  descriptionKey: string;
}

const MyIdentityAccessRequestComponent = ({
  titleKey,
  descriptionKey,
}: Props) => {
  const { t } = useTranslation();
  return (
    <div className={styles["header-section"]}>
      <FixaText tagName="h1" textStyle="Heading.L">
        {t(titleKey)}
      </FixaText>
      <FixaText
        tagName="p"
        textStyle="Body.M"
        className={styles["header-description"]}
      >
        {t(descriptionKey)}
      </FixaText>
      <div className={styles["button-section"]}>
        <FixaButton
          type="primary"
          fluid
          ssrIcon={LinkOutIconPath}
          iconPosition="trailing"
          text={t("requestAccessString")}
          onClick={() =>
            window.open(
              TEAM_MGMT_MYIDENTITY_URL,
              "_blank",
              "noopener,noreferrer"
            )
          }
        />
      </div>
    </div>
  );
};

export default MyIdentityAccessRequestComponent;
